<template>
  <div class="page">
    <div class="main">
      <van-loading v-if="loading" class="loading" size="24px" vertical>加载中...</van-loading>

      <!-- <div class="submitted" v-if="!loading && submitted">
        <img class="icon-success" src="https://static.huiyiji520.com/success-1692046533.png">
        <div>报名表已提交，等待审核</div>
      </div> -->
      <div class="submitted" v-if="!loading && submitted">
        <div class="hint">你的申请编号：<span class="uid">{{uid}}</span>
          <span class="btn-copy"
          v-clipboard:copy="uid"
          v-clipboard:success="copyUidSuccess"
          v-clipboard:error="copyUidError">复制</span>
        </div>
        <div class="hint">请扫描下方二维码 👇 添加机长</div>
        <div class="hint bold">给机长发送你的申请编号</div>
        <div class="hint">进行后续沟通确认</div>
        <img class="captain-qrcode" src="https://static.huiyiji520.com/cppic-1666347262-doushabao.jpg">
      </div>

      <div class="unsubmit" v-if="!loading && !submitted">

        <div class="question">
          <div class="q-header"><span class="star">*</span> 01 微信昵称</div>
          <van-field
            class="q-input"
            v-model="nickname"
            rows="1"
            autosize
            type="textarea"
            placeholder="请填写你的微信昵称"
            show-word-limit
          />
        </div>

        <div class="question">
          <div class="q-header"><span class="star">*</span> 02 性别</div>
          <van-field
            class="q-input"
            clickable
            readonly
            v-model="genderText"
            placeholder="请选择你的性别"
            @click="showGenderPicker = true"
          />
          <van-popup v-model="showGenderPicker" round position="bottom">
            <van-picker
              show-toolbar
              :columns="genderItems"
              @cancel="showGenderPicker = false"
              @confirm="onConfirmGender"
            />
          </van-popup>
        </div>

        <div class="question">
          <div class="q-header"><span class="star">*</span> 03 出生年份</div>
          <van-field
            class="q-input"
            clickable
            readonly
            v-model="birthyear"
            placeholder="请选择你的出生年份"
            @click="showBirthyearPicker = true"
          />
          <van-popup v-model="showBirthyearPicker" round position="bottom">
            <van-picker
              show-toolbar
              :columns="birthyearItems"
              @cancel="showBirthyearPicker = false"
              @confirm="onConfirmBirthyear"
            />
          </van-popup>
        </div>

        <div class="question">
          <div class="q-header"><span class="star">*</span> 04 身份</div>
          <van-field
            class="q-input"
            clickable
            readonly
            v-model="identityText"
            placeholder="请选择你的身份"
            @click="showIdentityPicker = true"
          />
          <van-popup v-model="showIdentityPicker" round position="bottom">
            <van-picker
              show-toolbar
              :columns="identityItems"
              @cancel="showIdentityPicker = false"
              @confirm="onConfirmIdentity"
            />
          </van-popup>
        </div>

        <div class="question">
          <div class="q-header"><span class="star">*</span> 05 学历</div>
          <van-field
            class="q-input"
            clickable
            readonly
            v-model="diplomaText"
            placeholder="请选择你的身份"
            @click="showDiplomaPicker = true"
          />
          <van-popup v-model="showDiplomaPicker" round position="bottom">
            <van-picker
              show-toolbar
              :columns="diplomaItems"
              @cancel="showDiplomaPicker = false"
              @confirm="onConfirmDiploma"
            />
          </van-popup>
        </div>

        <div class="question">
          <div class="q-header"><span class="star">*</span> 06 毕业院校(或在读院校)</div>
          <van-field
            class="q-input"
            v-model="school"
            rows="1"
            autosize
            type="textarea"
            placeholder="请填写你的毕业院校名称"
            show-word-limit
          />
        </div>

        <div class="question">
          <div class="q-header"><span class="star">*</span> 07 现居城市</div>
          <van-field
            class="q-input"
            clickable
            readonly
            v-model="addressText"
            placeholder="请选择你的现居城市"
            @click="showAddressPicker = true"
          />

          <van-popup class="citypicker" v-model="showAddressPicker" round position="bottom" :close-on-click-overlay="false">
            <van-cascader
            v-model="addressPickerValue"
            title="请选择现居城市"
            :options="addressItems"
            @close="showAddressPicker = false"
            @finish="confirmAddressPicker"
            />
          </van-popup>
        </div>

        <div class="question">
          <div class="q-header"><span class="star">*</span> 08 自我介绍/自我评价</div>
          <van-field
            class="q-input"
            v-model="introduction"
            rows="3"
            autosize
            type="textarea"
            placeholder="请填写你的自我介绍/自我评价"
            show-word-limit
          />
        </div>

        <div class="question">
          <div class="q-header"><span class="star">*</span> 09 特长/技能/兴趣爱好</div>
          <van-field
            class="q-input"
            v-model="hobby"
            rows="3"
            autosize
            type="textarea"
            placeholder="请填写你的特长/技能/兴趣爱好"
            show-word-limit
          />
        </div>

        <div class="question">
          <div class="q-header"><span class="star">*</span> 10 是否有小红书运营经验</div>
          <van-field
            class="q-input"
            clickable
            readonly
            v-model="practicexhsText"
            placeholder="请选择是否有小红书运营经验"
            @click="showPracticexhsPicker = true"
          />
          <van-popup v-model="showPracticexhsPicker" round position="bottom">
            <van-picker
              show-toolbar
              :columns="practicexhsItems"
              @cancel="showPracticexhsPicker = false"
              @confirm="onConfirmPracticexhs"
            />
          </van-popup>
        </div>

        <div class="question">
          <div class="q-header"><span class="star">*</span> 11 是否可以准备多个小红书账号</div>
          <van-field
            class="q-input"
            clickable
            readonly
            v-model="preparexhsText"
            placeholder="请选择是否可以准备多个小红书账号"
            @click="showPreparexhsPicker = true"
          />
          <van-popup v-model="showPreparexhsPicker" round position="bottom">
            <van-picker
              show-toolbar
              :columns="preparexhsItems"
              @cancel="showPreparexhsPicker = false"
              @confirm="onConfirmPreparexhs"
            />
          </van-popup>
        </div>

        <div class="question">
          <div class="q-header"><span class="star">*</span> 12 微信号</div>
          <van-field
            class="q-input"
            v-model="wechat"
            rows="1"
            autosize
            type="textarea"
            placeholder="请填写你的微信号"
            show-word-limit
          />
        </div>

        <div class="question">
          <div class="q-header"><span class="star">*</span> 13 手机号</div>
          <van-field
            class="q-input"
            v-model="phone"
            rows="1"
            autosize
            type="textarea"
            placeholder="请填写你的手机号"
            show-word-limit
          />
        </div>



        <div class="btn-submit" @click="submitForm">提交</div>

      </div>
    </div>
  </div>
</template>

<script>
// import wx from 'weixin-js-sdk'
import { Toast, Dialog, Loading, Field, Picker, Popup, Cascader} from 'vant'

export default{
  components: {
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Loading.name]: Loading,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Cascader.name]: Cascader
  },
  data(){
    return {
      uid: "",
      openid: "",
      nickname: "",

      genderValue: "",
      genderText: "",
      genderItems: [{ text: '男', value: 'male' }, { text: '女', value: 'female' }],
      showGenderPicker: false,

      birthyear: "",
      birthyearItems: this.createBirthyearItems(),
      showBirthyearPicker: false,

      identityValue: "",
      identityText: "",
      identityItems: [{ text: '上班族', value: 'worker' }, { text: '学生', value: 'student' },  { text: '其他', value: 'others' }],
      showIdentityPicker: false,

      diplomaValue: "",
      diplomaText: "",
      diplomaItems: [{ text: '高中', value: 'high_school' }, { text: '大专', value: 'junior_college' },  { text: '本科', value: 'undergraduate' }, { text: '硕士', value: 'master' }, { text: '博士', value: 'doctor' },  { text: '其他', value: 'others' }],
      showDiplomaPicker: false,

      school: "",

      province: "",
      city: "",
      addressText: "",
      addressItems: [],
      addressPickerValue: "",
      showAddressPicker: false,

      introduction: "",
      hobby: "",

      practicexhsValue: "",
      practicexhsText: "",
      practicexhsItems: [{ text: '无经验', value: '0' }, { text: '有经验', value: '1' }],
      showPracticexhsPicker: false,

      preparexhsValue: "",
      preparexhsText: "",
      preparexhsItems: [{ text: '可以', value: '1' }, { text: '不可以', value: '0' }],
      showPreparexhsPicker: false,

      wechat: "",
      phone: "",

      loading: true,
      submitted: false
    }
  },
  methods: {
    getSubmitHistory(){
      let openid = this.$store.state.userinfo.openid
      // Toast(`openid: ${openid}`)
      this.$api.get('/freelancer/check_submit_history_of_xhs', {openid: openid}, res => {
        if(res.code == 200){
          this.loading = false
          this.submitted = res.submitted
          this.uid = res.uid
        }
      })
    },
    onConfirmGender(gender, index){
      // console.log(`onConfirmGender genderValue: ${gender.value}, genderText: ${gender.text}, index: ${index}`)
      this.genderText = gender.text
      this.genderValue = gender.value
      this.showGenderPicker = false
    },
    createBirthyearItems(){
      // let rangeArray = (start, end) => Array(end - start + 1).fill(0).map((v, i) => i + start)
      let rangeArray = (start, end) => Array(start - end + 1).fill(0).map((v, i) => start - i)
      return rangeArray(2014, 1960)
    },
    onConfirmBirthyear(value, index){
      this.birthyear = value
      this.showBirthyearPicker = false
    },
    onConfirmIdentity(item, index){
      this.identityText = item.text
      this.identityValue = item.value
      this.showIdentityPicker = false
    },
    onConfirmDiploma(item, index){
      this.diplomaText = item.text
      this.diplomaValue = item.value
      this.showDiplomaPicker = false
    },
    confirmAddressPicker({ selectedOptions }){
      this.province = selectedOptions[0].text
      this.city = selectedOptions[1].text
      this.addressText = `${this.province}-${this.city}`
      this.showAddressPicker = false
    },
    onConfirmPracticexhs(item, index){
      this.practicexhsText = item.text
      this.practicexhsValue = item.value
      this.showPracticexhsPicker = false
    },
    onConfirmPreparexhs(item, index){
      this.preparexhsText = item.text
      this.preparexhsValue = item.value
      this.showPreparexhsPicker = false
    },

    submitForm(){
      if(this.nickname.trim().length == 0){
        Toast('请填写你的微信昵称')
        return;
      }

      if(this.genderText == ""){
        Toast('请选择你的性别')
        return;
      }

      if(this.birthyear == ""){
        Toast('请选择你的出生日期')
        return;
      }

      if(this.identityText == ""){
        Toast('请选择你的身份')
        return;
      }

      if(this.diplomaText == ""){
        Toast('请选择你的学历')
        return;
      }

      if(this.school.trim().length == 0){
        Toast('请填写你的毕业院校')
        return;
      }

      if(this.addressText == ""){
        Toast('请选择你的现居城市')
        return;
      }

      if(this.introduction.trim().length == 0){
        Toast('请填写你的自我介绍/自我评价')
        return;
      }

      if(this.hobby.trim().length == 0){
        Toast('请填写你的特长/技能/兴趣爱好')
        return;
      }

      if(this.practicexhsText == ""){
        Toast('请选择你是否有小红书运营经验')
        return;
      }

      if(this.preparexhsText == ""){
        Toast('请选择你是否可以准备多个小红书账号')
        return;
      }

      if(this.wechat.trim().length == 0){
        Toast('请填写你的微信号')
        return;
      }

      if(this.phone.trim().length == 0){
        Toast('请填写你的手机号')
        return;
      }

      this.loading = true
      let openid = this.$store.state.userinfo.openid
      this.$api.post('/freelancer/submit_apply_form_of_xhs', {
        openid: openid, nickname: this.nickname, gender: this.genderValue, identity: this.identityValue,
        birthyear: this.birthyear, school: this.school, province: this.province, city: this.city,
        introduction: this.introduction, hobby: this.hobby, wechat: this.wechat, phone: this.phone,
        diploma: this.diplomaValue, practice_xhs: this.practicexhsValue, prepare_xhs: this.preparexhsValue
      }, res => {
        if(res.code == 200){
          this.loading = false
          this.uid = res.uid
          this.submitted = true
        }else{
          Toast('网络异常，请稍后再试～')
        }
      })
    },

    getProvincesAndCities(){
      this.$api.get('/district/get_provinces_and_cities', {}, res => {
        if(res.code == 200){
          this.addressItems = res.provinces
        }
      })
    },
    copyUidSuccess(){
      Toast('复制成功')
    },
    copyUidError(){
      Toast('复制失败，请重试')
    }
  },
  mounted(){
    this.getSubmitHistory()
    this.getProvincesAndCities()
  }
}
</script>

<style scoped>
.page{
  min-height:100vh;
  background-color: #fff;
  padding:20px;
  width: 100%;
  height: 100%;
}
.loading{margin-top:30%;}
/* .submitted{padding-top:30%;font-size:40px;}
.submitted .icon-success{width:150px;height:150px;margin:0px auto;margin-bottom:50px;} */
.submitted{padding-top:30%;font-size:32px;color:#333;}
.submitted .hint{margin-bottom:10px;}
.submitted .hint.bold{font-weight:bold;}
.submitted .uid{font-weight:bold;color:#0f88eb;}
.submitted .btn-copy{
  color:#f39c12;font-size:26px;margin-left:15px;border:1px solid #f39c12;border-radius:5px;
  padding:4px 15px;
}
.submitted .captain-qrcode{
  width:320px;height:320px;margin:0px auto;margin-top:30px;
  box-shadow:0px 2px 6px rgba(0,0,0,0.15);
}
.unsubmit{padding-top:50px;padding-bottom:70px;}
.unsubmit .question{text-align:left;margin-bottom:70px;}
.unsubmit .question .q-header{font-size:32px;margin-bottom:20px;}
.unsubmit .question .q-header .star{color:#dd4b39;}
.unsubmit .question .q-input{border-radius:10px;}
.unsubmit .btn-submit{background:#0f88eb;color:#fff;font-size:32px;height:80px;line-height:80px;border-radius:10px;}
</style>
